import { useQuery } from '@apollo/client';
import { useClientUser } from '@/hooks';
import { ORG_CLIENTS } from '../queries';

// Org context for carrier-facing surfaces: the list of org entities (for the parent-entity filter +
// name lookups) and the role flags surfaces need to decide org-wide vs own-account scoping. The
// ORG_CLIENTS query is SKIPPED for non-carriers, so org-level reads only ever run for carriers
// (both carrier admins and regular carriers get the org-wide view; shippers stay scoped to self).
export const useOrgClients = () => {
    const { isCarrierAdmin, accountType, organization_id, client_id } = useClientUser();
    const isCarrier = accountType === 'carrier';
    const isShipper = accountType === 'shipper';
    const { data, loading } = useQuery(ORG_CLIENTS, {
        variables: { organization_id },
        skip: !isCarrier || !organization_id,
    });

    return {
        isCarrierAdmin,
        isCarrier,
        isShipper,
        organizationId: organization_id,
        currentClientId: client_id,
        orgClients: data?.clients || [],
        loading,
    };
};
